import Project1 from '../assets/ecommerce-site-demo.gif';
import Project2 from '../assets/restaurant-reservation-demo.gif';
import Project3 from '../assets/we-love-movies-demo.gif';
import Project4 from '../assets/flashcard-app-demo.gif';
import Project5 from '../assets/open-ai-img-demo.gif';
import Project6 from '../assets/qr-code-demo-2.gif';

export const ProjectList = [
  {
    name: 'Flowmazon: Ecommerce website storefront',
    image: Project1,
    skills: 'TypeScript, Next.js, DaisyUI, Prisma, MongoDB',
    link: 'https://github.com/kerimedeiros/nextjs-ecommerce-project',
  },
  {
    name: 'Restaurant Reservation System',
    image: Project2,
    skills: 'JavaScript, React, Node.js, Express.js, Knex.js, PostgreSQL',
    link: 'https://github.com/kerimedeiros/restaurant-reservation-app',
  },
  {
    name: 'We Love Movies API',
    image: Project3,
    skills: 'PostgreSQL, Node.js, Express.js, Knex.js, CORS',
    link: 'https://github.com/kerimedeiros/we-love-movies',
  },
  {
    name: 'Flashcard Tool',
    image: Project4,
    skills: 'JavaScript, React, HTML, CSS',
    link: 'https://github.com/kerimedeiros/flashcard-app',
  },
  {
    name: 'OpenAI Image Generator',
    image: Project5,
    skills: 'OpenAI Images API (DALL-E), JavaScript, Node.js, HTML, CSS',
    link: 'https://github.com/kerimedeiros/open-ai-image-generator',
  },
  {
    name: 'QR Code Generator',
    image: Project6,
    skills: 'JavaScript, HTML, CSS',
    link: 'https://github.com/kerimedeiros/qr-code-generator',
  },
];
